import { api } from './client';

export interface AgreementUploadUrlResponse {
  upload_url: string;
  s3_key: string;
  content_type: string;
  expires_in: number;
}

export interface AgreementViewUrlResponse {
  url: string;
  filename: string;
  content_type: string;
  expires_in: number;
}

export async function getInformationDisclosureAgreementViewUrl(
  clientId: string,
  agreementId: string,
): Promise<AgreementViewUrlResponse> {
  const response = await api.get<AgreementViewUrlResponse>(
    `/clients/${clientId}/information-disclosure-agreements/${agreementId}/view-url`,
  );
  return response.data;
}

export async function deleteInformationDisclosureAgreement(
  clientId: string,
  agreementId: string,
): Promise<void> {
  await api.delete(`/clients/${clientId}/information-disclosure-agreements/${agreementId}`);
}

export async function uploadInformationDisclosureAgreement(
  clientId: string,
  file: File,
): Promise<void> {
  const presign = await api.post<AgreementUploadUrlResponse>(
    `/clients/${clientId}/information-disclosure-agreement/upload-url`,
    {
      filename: file.name,
      content_type: file.type || 'application/pdf',
    },
  );
  await uploadPdfToS3(presign.data.upload_url, file, presign.data.content_type);
  await api.post(`/clients/${clientId}/information-disclosure-agreement/complete`, {
    s3_key: presign.data.s3_key,
    filename: file.name,
    content_type: presign.data.content_type,
  });
}

function uploadPdfToS3(uploadUrl: string, file: File, contentType: string): Promise<void> {
  if (uploadUrl.startsWith('mock://')) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', uploadUrl);
    xhr.setRequestHeader('Content-Type', contentType || 'application/pdf');
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) resolve();
      else reject(new Error(`PDF upload failed: HTTP ${xhr.status}`));
    };
    xhr.onerror = () => reject(new Error('PDF upload network error'));
    xhr.send(file);
  });
}
